import React, { Component } from 'react'
import Header from '../components/Header'
import { Icon, Menu, Segment } from 'semantic-ui-react'
import { Link, withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import AuthenticationStore from '../stores/AuthenticationStore'
import { inject, observer } from 'mobx-react'

@inject('authenticationStore')
@withRouter
@observer
class ClientLayout extends Component {
  static propTypes = {
    children: PropTypes.element.isRequired,
    authenticationStore: PropTypes.instanceOf(AuthenticationStore),
    location: PropTypes.object
  }

  render () {
    const { location, authenticationStore } = this.props

    return (
      <>
        <Header authenticationStore={authenticationStore} />
        <Menu icon='labeled' widths={2} className='top-header background-primary-blue' inverted>
          <Menu.Item
            name='Calendrier' as={Link} to='/next-events'
            active={location.pathname.startsWith('/next-events')}
          >
            <Icon name='calendar alternate' />
            Prochaines inspections
          </Menu.Item>

          <Menu.Item
            name='Archives' as={Link} to='/archives'
            active={location.pathname.startsWith('/archives')}
          >
            <Icon name='archive' />
            Rapports
          </Menu.Item>
        </Menu>
        <Segment basic padded>
          {this.props.children}
        </Segment>
      </>
    )
  }
}

export default ClientLayout
